module.exports = __webpack_public_path__ + "static/media/bg-mletter-footer.f881ada0.svg";